import { render } from "./ContentGroup.vue?vue&type=template&id=58e97d6c&scoped=true"
import script from "./ContentGroup.vue?vue&type=script&lang=js"
export * from "./ContentGroup.vue?vue&type=script&lang=js"

import "./ContentGroup.vue?vue&type=style&index=0&id=58e97d6c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e97d6c"]])

export default __exports__